export const PRIMARY_COLOR = '#ffcb05';
export const HOVER_PRIMARY_COLOR = '#ffcb05';
export const HOVER_PRIMARY2_COLOR = 'rgb(254 190 16)';
export const TEXT_PRIMARY_COLOR = '#004570';
export const TEXT_WARNING_COLOR = '#6F4901';
export const TEXT_SUCCESS_COLOR = '#003946';
export const TEXT_SILVER_COLOR = '#493D32';
export const TEXT_ERROR_COLOR = 'rgb(124 19 40)';
export const TEXT_SECONDARYY_COLOR = 'rgb(91 21 73)';
export const TEXT_TURQUOISE_COLOR = 'rgb(1 70 70)';

export const SECONDARY_COLOR = '#004c6c';
export const HOVER_SECONDARY_COLOR = '#c0d5dd';
export const TEXT_SECONDARY_COLOR = '#fff';

export const BORDER_COLOR = 'rgb(220 222 223)';
export const READ_ONLY_COLOR = '#eee';
export const DISABLED_COLOR = '#000000de';

export const BACKGROUND_STEP_COLOR = '#c1c1c1';
export const BACKGROUND_HEADER_POLICY_DETAIL = '#e8f2fa';
export const BACKGROUND_BREADCUM_INFO_CONTRACT = '#f0f5ff';
export const BACKGROUND_SUCCESS_ALERT = 'rgb(241 247 247)';
export const BACKGROUND_PRIMARY_COLOR = '#94D9F4';
export const BACKGROUND_WARNING_COLOR = '#FFE994';
export const BACKGROUND_SUCCESS_COLOR = '#D6E3E6';
export const BACKGROUND_SILVER_COLOR = '#E2D9D0';
export const BACKGROUND_ERROR_COLOR = 'rgb(250 183 188)';
export const BACKGROUND_SECONDARY_COLOR = 'rgb(229 190 221)';
export const BACKGROUND_TURQUOISE_COLOR = 'rgb(176 227 219)';
export const BACKGROUND_POLICY_STATUS_GROUP_1_COLOR = '#CCEAC7';
export const TEXT_POLICY_STATUS_GROUP_1_COLOR = '#15480F';
export const BACKGROUND_POLICY_STATUS_GROUP_2_COLOR = '#FFDAB2';
export const TEXT_POLICY_STATUS_GROUP_2_COLOR = '#9D461B';
export const BACKGROUND_POLICY_STATUS_GROUP_3_COLOR = '#B0E3DB';
export const TEXT_POLICY_STATUS_GROUP_3_COLOR = '#014646';
export const BACKGROUND_POLICY_STATUS_GROUP_4_COLOR = '#94D9F4';
export const TEXT_POLICY_STATUS_GROUP_4_COLOR = '#004570';
export const BACKGROUND_POLICY_STATUS_GROUP_5_COLOR = '#E5BEDD';
export const TEXT_POLICY_STATUS_GROUP_5_COLOR = '#5B1549';
export const BACKGROUND_POLICY_STATUS_GROUP_6_COLOR = '#FAB7BC';
export const TEXT_POLICY_STATUS_GROUP_6_COLOR = '#7C1328';
export const BACKGROUND_POLICY_STATUS_GROUP_7_COLOR = '#EAEBEB';
export const TEXT_POLICY_STATUS_GROUP_7_COLOR = '#3D4142';

export const WHITE = '#ffffff';
export const BLACK = '#000';
export const GREY = '#f1f1f0';
export const YELLOW = '#FFF8E0';
export const NOTE_COLOR = 'rgb(158 26 48)';
export const HIGHT_LIGHT_COLOR = 'rgb(220,29,61)';
export const SECONDARY_TABLE_COLOR = 'rgb(230 239 239)';
export const EAPP_NO_COLOR = 'rgba(0, 69, 112, 1)';
export const TEXT_GREEN_COLOR = '#1bf603';
